export default __webpack_public_path__ + "static/media/printIcon.0b6d1244.svg";